import { PurposeOption } from "../../../client_onboarding/ClientsGrid/ClientsGrid.utils";

export interface SelectedField {
  id: number;
  label: string;
  value: string;
  type: string;
  code: string;
  category?: string;
}

export const CATEGORY_LABEL_MAP: Record<string, string> = {
  ACCOUNTING_AUDIT: "Accounting & Auditing",
  BILLING_INFO: "Billing Information",
  CLIENT_INFO: "Client Information",
  DOCUMENT_TYPE: "Client Document",
  INTERNAL_CUSTOM_FIELDS: "In-built Custom Fields",
  MARKETING_INFO: "Marketing Information",
  PARTNER_INFO: "Partner Information",
  TAX_INFO: "Tax Information",
};

export const CATEGORY_ORDER: string[] = [
  "CLIENT_INFO",
  "BILLING_INFO",
  "TAX_INFO",
  "ACCOUNTING_AUDIT",
  "PARTNER_INFO",
  "MARKETING_INFO",
  "DOCUMENT_TYPE",
  "INTERNAL_CUSTOM_FIELDS",
];

export interface SelectOption {
  id: string;
  label: string;
  value: string;
}

export interface FormConfig {
  formName: string;
  lineOfService: PurposeOption | null;
  formType: SelectOption | null;
  instructions: string;
}

export type IntakeFormAIMode = "generate" | "modify";

export interface IntakeFormAIModalProps {
  show: boolean;
  onHide: () => void;
  onDone?: () => void;
  mode?: IntakeFormAIMode;
  showFieldPicker?: boolean;
  initialConfig?: Partial<FormConfig>;
  formId?: number;
  templateId?: number;
  formType?: string;
  currentFieldCodes?: string[];
}

export const FORM_TYPE_OPTIONS: SelectOption[] = [
  { id: "1", label: "Intake", value: "Intake" },
  { id: "2", label: "Evaluate", value: "Evaluate" },
];

export const TYPE_ICON_MAP: Record<string, string> = {
  text: "T",
  email: "@",
  phone: "#",
  date: "D",
  select: "▾",
  dropdown: "▾",
  checkbox: "✓",
  boolean: "✓",
  file: "F",
};

export const EMPTY_CONFIG: FormConfig = {
  formName: "",
  lineOfService: null,
  formType: null,
  instructions: "",
};
